import { invalidateInventory } from '../collection/inventoryInvalidation';
import { Location } from '../../domain/location';
import { InventoryAuthority } from '@qkindex/contracts';
import { locationService } from '../../services/locationService';
import { logger } from '../../services/logger';
import { useFeedback } from '../feedback/FeedbackProvider';
import { LocationUpdate } from './components/LocationEditorDialog';

export function useLocationEditorActions(authority?: InventoryAuthority) {
  const { confirm, notify } = useFeedback();
  return {
    async saveLocation(update: LocationUpdate) {
      if (
        !authority ||
        (update.collectionId && update.collectionId !== authority.collectionId)
      )
        return false;
      try {
        await locationService.rename(
          authority,
          update.id,
          update.name,
          update.description,
        );
        // Renaming also updates compatibility item references; those IDs are not
        // returned by the service, so items still require reconciliation.
        invalidateInventory({
          ...authority,
          resources: ['items', 'locations'],
          reloadLocationIds: [update.id],
        });
        return true;
      } catch (error) {
        logger.error('Location update failed.', error);
        notify(
          error instanceof Error
            ? error.message
            : 'Location could not be updated.',
          'error',
        );
        return false;
      }
    },
    async deleteLocation(location: Location) {
      if (
        !authority ||
        (location.collectionId &&
          location.collectionId !== authority.collectionId) ||
        !(await confirm(
          `Delete “${location.name}”? This cannot be undone.`,
          'Delete location',
        ))
      )
        return false;
      try {
        await locationService.delete(authority, location.id, location.name);
        invalidateInventory({
          ...authority,
          resources: ['locations'],
          deletedLocationIds: [location.id],
        });
        return true;
      } catch (error) {
        logger.error('Location deletion failed.', error);
        notify(
          error instanceof Error
            ? error.message
            : 'Location could not be deleted.',
          'error',
        );
        return false;
      }
    },
  };
}
